// Übersetzungsobjekte
const translations = {
    en: {
        "Benachrichtigung wenn lieferbar": "Notify me when back in stock",
        "Benachrichtigung per Mail": "Notify me via email",
        "Wir senden dir eine Benachrichtigung sobald das Produkt wieder bestellbar und versandbereit ist:": "We will send you a notification as soon as this product is ready to order and to be shipped:",
        "Wir respektieren deine persönlichen Daten und geben diese nicht weiter.": "We respect your privacy and don't share your email with anybody.",
        "Benachrichtigung anfordern": "Request notification",
        "Informationen per Mail abonnieren.": "Subscribe to our mailings to stay up to date."
    },
    fr: {
        "Benachrichtigung wenn lieferbar": "Avertir lorsque disponible",
        "Benachrichtigung per Mail": "M'avertir par mail",
        "Wir senden dir eine Benachrichtigung sobald das Produkt wieder bestellbar und versandbereit ist:": "Nous vous enverrons une notification dès que ce produit sera prêt à être commandé et expédié:",
        "Wir respektieren deine persönlichen Daten und geben diese nicht weiter.": "Nous respectons tes données personnelles et ne les transmettons pas.",
        "Benachrichtigung anfordern": "Demander notification",
        "Informationen per Mail abonnieren.": "S'abonner aux informations par e-mail"
    },
    es: {
        "Benachrichtigung wenn lieferbar": "Notificarme cuando esté disponible",
        "Benachrichtigung per Mail": "Notificarme por mail",
        "Wir senden dir eine Benachrichtigung sobald das Produkt wieder bestellbar und versandbereit ist:": "Le enviaremos una notificación en cuanto este producto esté listo para ser pedido y enviado:",
        "Wir respektieren deine persönlichen Daten und geben diese nicht weiter.": "Respetamos sus datos personales y no los transmitimos.",
        "Benachrichtigung anfordern": "Solicitar notificación",
        "Informationen per Mail abonnieren.": "Recibir información por correo electrónico"
    },
    sv: {
        "Benachrichtigung wenn lieferbar": "Meddela mig när det är tillgängligt",
        "Benachrichtigung per Mail": "Meddela mig via mail",
        "Wir senden dir eine Benachrichtigung sobald das Produkt wieder bestellbar und versandbereit ist:": "Vi kommer att skicka ett meddelande till dig så snart produkten är klar att beställa och skickas:",
        "Wir respektieren deine persönlichen Daten und geben diese nicht weiter.": "Vi respekterar dina personuppgifter och lämnar dem inte vidare.",
        "Benachrichtigung anfordern": "Begär meddelande",
        "Informationen per Mail abonnieren.": "Prenumerera på information via e-post"
    }
};

// Funktion zum Ermitteln der Sprache
function getLanguage() {
    return document.documentElement.lang || 'de'; // Default
}

// Funktion zum Übersetzen des "timesact"-Textes
function translateTimesactText() {
    const lang = getLanguage(); // Die aktuelle Sprache ermitteln
    const timesactButton = document.querySelector('.timesact-button-bis'); // .timesact-button-bis suchen

    if (timesactButton && timesactButton.textContent.includes('Benachrichtigung wenn lieferbar')) {
        timesactButton.textContent = translations[lang]["Benachrichtigung wenn lieferbar"] || timesactButton.textContent; // Text übersetzen
    }

    // Funktion zum Übersetzen der Inhalte im Popup
    function translatePopupBody() {
        const popupBody = document.querySelector('.timesact_bis_popup_body'); // Popup-Body suchen
        if (popupBody) {
            const heading = popupBody.querySelector('.timesact_bis_heading');
            if (heading && heading.textContent.includes('Benachrichtigung per Mail')) {
                heading.textContent = translations[lang]["Benachrichtigung per Mail"] || heading.textContent;
            }

            const desc = popupBody.querySelector('.timesact_bis_desc');
            if (desc && desc.textContent.includes('Wir senden dir eine Benachrichtigung sobald das Produkt wieder bestellbar und versandbereit ist:')) {
                desc.textContent = translations[lang]["Wir senden dir eine Benachrichtigung sobald das Produkt wieder bestellbar und versandbereit ist:"] || desc.textContent;
            }

            const note = popupBody.querySelector('.timesact_bis_note');
            if (note && note.textContent.includes('Wir respektieren deine persönlichen Daten und geben diese nicht weiter.')) {
                note.textContent = translations[lang]["Wir respektieren deine persönlichen Daten und geben diese nicht weiter."] || note.textContent;
            }

            const submitButton = popupBody.querySelector('.timesact_bis_submit_button');
            if (submitButton && submitButton.textContent.includes('Benachrichtigung anfordern')) {
                submitButton.textContent = translations[lang]["Benachrichtigung anfordern"] || submitButton.textContent;
            }

            const subscribe = popupBody.querySelector('.timesact_bis_subscribe');
            if (subscribe && subscribe.textContent.includes('Informationen per Mail abonnieren.')) {
                subscribe.textContent = translations[lang]["Informationen per Mail abonnieren."] || subscribe.textContent;
            }
        }
    }

    // Klick-Event Listener für .timesact-button-bis, um das Popup zu öffnen und zu übersetzen
    const timesactButtonClick = document.querySelector('.timesact-button-bis');
    if (timesactButtonClick) {
        timesactButtonClick.addEventListener('click', function() {
            setTimeout(function() {
                translatePopupBody(); // Warte kurz, bis das Popup sichtbar ist, dann übersetze es
            }, 500); // 500ms Verzögerung, um das Popup nach dem Klick sichtbar zu machen
        });
    }
}

// MutationObserver, der auf Änderungen im DOM hört
const observer = new MutationObserver(function(mutationsList) {
    mutationsList.forEach(function(mutation) {
        if (mutation.type === 'childList') {
            // Wenn die .timesact_bis_popup_body oder .timesact-button-bis Elemente hinzugefügt wurden
            if (mutation.target.matches('.timesact_bis_popup_body') || mutation.target.matches('.buy-buttons')) {
                translateTimesactText(); // Übersetze den Text
            }
        }
    });
});

// Optionen für den MutationObserver
const config = { childList: true, subtree: true };

// Beobachte den gesamten DOM
observer.observe(document.body, config);

// Initiale Übersetzung ausführen, falls der Text sofort im DOM ist
translateTimesactText();
